const routes = {
  fudr: 'fudr',
  containers: {
    createBrand: 'create-brand',
    createRestaurant: 'create-restaurant',
  },
};

export default routes;
